import type { CoverageAreaInput, CoverageLookupHit, CoveragePartyInput } from "@/lib/coverage/coverageLookup";
import { manufacturingFetch } from "@/lib/manufacturingClient";

export type CoverageLocationPin = { id: string; name: string; lat: number; lng: number };

export type CoverageBoard = {
  ok: true;
  parties: CoveragePartyInput[];
  areas: Array<CoverageAreaInput & { id: string }>;
  locations: CoverageLocationPin[];
};

export type CoverageLookupResult = {
  ok: true;
  point: { lat: number; lng: number; precision: "rooftop" | "city"; address: string };
  hits: CoverageLookupHit[];
};

const json = { "Content-Type": "application/json" };

export function fetchCoverageBoard() {
  return manufacturingFetch<CoverageBoard>("/api/coverage/board", { method: "GET" });
}

export function saveCoverageParty(body: Record<string, unknown>) {
  return manufacturingFetch<{ ok: true; party: CoveragePartyInput }>("/api/coverage/parties", {
    method: "POST",
    headers: json,
    body: JSON.stringify(body),
  });
}

export function saveCoverageAreas(body: Record<string, unknown>) {
  return manufacturingFetch<{ ok: true }>("/api/coverage/areas", {
    method: "POST",
    headers: json,
    body: JSON.stringify(body),
  });
}

export function lookupCoverageAddress(body: { address: string; program: string }) {
  return manufacturingFetch<CoverageLookupResult>("/api/coverage/lookup", {
    method: "POST",
    headers: json,
    body: JSON.stringify(body),
  });
}

export const KM_PER_MILE = 1.609344;

export function milesToKm(miles: number): number {
  return Math.round(miles * KM_PER_MILE * 1000) / 1000;
}

export function kmToMiles(km: number): number {
  return Math.round((km / KM_PER_MILE) * 10) / 10;
}
